/**
 * New reward statuses for version 2.
 */
export enum REWARD_STATUS {
  None = 0,
  Favourite = 1,
  ComingSoon = 2,
  ViewableOnly = 3,
  DisabledManualEntry = 4,
  LimitedStock = 5,
  SoldOut = 6,
  LimitReached = 7,
  NotEnoughPoints = 8,
  NewItem = 9,
  LimitedItem = 10,
}
